<template>
    <div>
        <v-overlay :model-value="loading"
                   class="align-center justify-center">
            <v-progress-circular color="primary"
                                 indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <v-card variant="flat" class="pa-4 my-2">
            <div>
                <v-text-field label="Search..."
                              prepend-icon="mdi-magnify"
                              v-model="searchTerm"
                              density="compact"
                              clearable></v-text-field>
            </div>
            <v-table>
                <thead>
                    <tr>
                        <th style="width:8%">Job</th>
                        <th style="width:18%">Cust#</th>
                        <th style="width:18%">Customer</th>
                        <th style="width:18%">Colours</th>
                        <th style="width:8%">Completed</th>
                        <th v-if="status >= $constants.jobs.JOBSTAT_INVOICE" style="width:8%">Task</th>
                        <th style="width:8%">Total</th>
                        <th v-if="status >= $constants.jobs.JOBSTAT_INVOICE" style="width:8%"></th>
                    </tr>
                </thead>
                <tbody v-if="data">
                    <tr v-for="job in filteredJobs" :key="job.id">
                        <td>
                            <job-link :job="job" :search-term="searchTerm"></job-link>
                        </td>
                        <td>
                            <span v-html="formatSearchName(job.customerNumber, searchTerm)"></span>
                        </td>
                        <td>
                            <contact-link :contact="job.contact" :search-term="searchTerm"></contact-link>
                        </td>
                        <td>
                            {{ job.colour?.name }}
                        </td>
                        <td>
                            <span v-if="dateCompleted(job.jobTasks)">{{ dateCompleted(job.jobTasks) }}</span>
                        </td>
                        <td v-if="status >= $constants.jobs.JOBSTAT_INVOICE">
                            {{ job.workType }}
                        </td>
                        <td>
                            ${{ numberWithCommas(job.jobSubTotal,2)}}
                        </td>
                        <td v-if="status >= $constants.jobs.JOBSTAT_INVOICE">
                            <v-btn v-if="job.status == $constants.jobs.JOBSTAT_INVOICE"
                                   prepend-icon="mdi-invoice-text-outline"
                                   class="ml-1"
                                   variant="tonal"
                                   color="info"
                                   @click="markInvoiced(job)">Mark Invoiced</v-btn>
                            <v-btn v-if="job.status > $constants.jobs.JOBSTAT_INVOICE"
                                   prepend-icon="mdi-check-circle"
                                   class="ml-1"
                                   color="secondary"
                                   variant="tonal"
                                   disabled>Job Invoiced</v-btn>
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </v-card>
    </div>
</template>
<script>
    import { mapActions } from "vuex";
    import { numberWithCommas } from "../../mixins/numberMixins";
    import { formatSearchName } from "../../mixins/searchMixins";
    function initialState() {
        return {
            loading: false,
            today: null,
            data: [],
            searchTerm: ''
        };
    }
    export default {
        name: "StatusJobs",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadData();
        },
        props: {
            status: Number
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
                "updateSmartJobStatus"
            ]),
            formatSearchName,   
            numberWithCommas,
            loadData() {
                this.loading = true;
                this.$api.get('/dashboard/statusjobs?status=' + this.status)
                    .then(res => {
                        this.data = res.data;
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("There was an issue getting the jobs.");
                    });
            },
            markInvoiced(job){
                job.status = this.$constants.jobs.JOBSTAT_COMP;
                this.updateSmartJobStatus({ job: job, status: this.$constants.jobs.JOBSTAT_COMP});
            },
            dateCompleted(tasks){
                let task = tasks.find(item => item.status != this.$constants.jobs.JOBSTAT_INVOICE);
                if (task) {
                    return this.$dayjs(task.targetStartDate).format("DD/MM/YYYY");
                }
                return '';
            }
        },
        computed: {
            filteredJobs() {
                if (this.data) {
                    if (this.searchTerm && this.searchTerm.length > 0) {
                        let upperSearch = this.searchTerm.toUpperCase();
                        return this.data.filter(item => {
                            return item.customerNumber.toUpperCase().includes(upperSearch) || item.name.toUpperCase().includes(upperSearch) || item.contact.name.toUpperCase().includes(upperSearch);
                        });
                    }
                    return this.data;
                }
                return [];
            }
        },
        watch: {
        }
    };
</script>
<style scoped>
</style>